import { Component, computed, input } from '@angular/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxIconComponent, OnyxTooltipDirective } from '@onyx/angular';

@Component({
  selector: 'app-order-loaded-trailer-icon',
  imports: [OnyxIconComponent, OnyxTooltipDirective],
  templateUrl: './order-loaded-trailer-icon.component.html',
  styleUrl: './order-loaded-trailer-icon.component.scss',
})
export class OrderLoadedTrailerIconComponent {
  public readonly color =
    input.required<Extract<OnyxColor, 'black' | 'sea-green'>>();
  public readonly size = input.required<number>();

  protected tooltip = computed(() =>
    this.color() === 'black'
      ? 'orders.ordersList.cells.loadedTrailer'
      : 'labels.loadedForeignTrailer',
  );
}
